<template>
  <b-row class="my-2 px-3">
    <b-col sm="12" md="12" lg="12" xl="12">
      <!-- {{ itemDetails }} -->
      <!-- {{ insert_data }} -->

      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">ITEM CODE</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">{{ insert_data.Code }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">CODE</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">{{ insert_data.ProductId }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">LEGACY ITEM ID</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">{{ insert_data.LegacyItemId }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">HSN CODE</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">{{ itemDetails.HSNCode }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">DESCRIPTIVE NAME</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">{{ itemDetails.Name }}</p>
        </b-col>
      </b-row>
      <!-- <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                    <p class="sidbar-label">VAT ON</p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                    <p class="sidbar-val">{{ itemDetails.VatOn }}</p>
                </b-col>
            </b-row> -->
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">MARK UP %</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">{{ insert_data.MarkupPercentage }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">QTY.VALUE</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="sidbar-val">₹{{ insert_data.MRP }}</p>
        </b-col>
      </b-row>
      <!-- //Highlight -->
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">CATEGORY</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="high-val">{{ itemDetails.ItemCategoryName }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">GROUP</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="high-val">{{ itemDetails.ItemGroupName }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">SUB GROUP</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="high-val">{{ itemDetails.ItemSubGroupName }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">RACK</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="high-val">{{ itemDetails.RackName }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
          <p class="sidbar-label">BOX</p>
        </b-col>
        <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-end">
          <p class="high-val">{{ itemDetails.BoxName }}</p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
// import SupplierCategoryMappingService from "../../../../modules/Inventory/Service//SupplierCategoryMappingService";
import service from "../../../../Service/ItemMasService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";

export default defineComponent({
  props: {
    itemId: {
      type: Number,
      default: ref(0),
    },
  },
  setup(props) {
    const router = useRoute();
    const Storeid = ref(0);
    let itemDetails = ref({
      ItemCode: "",
      ProductId: "",
      HSNCode: "",
      Name: "",
      VatOn: "",
      MarkupPercentage: "",
      MRP: "",
      ItemCategoryName: "",
      ItemGroupName: "",
      ItemSubGroupName: "",
      BoxName: "",
      RackName: "",
    });
    onMounted(() => {
      Storeid.value = Number(
        router.query.StroeId ? router.query.StroeId : router.query.Id
      );
      // ItemDetails()
      init();
    });

    // async function ItemDetails() {
    //     const result = await service.ListItemByStoreId(Storeid.value);
    //     console.log(result['result'].filter((item) => item.Id == props.itemId)[0]);
    //     Object.assign(itemDetails.value, result['result'].filter((item) => item.Id == props.itemId)[0])
    // }
    const route = useRoute();
    let insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      Code: "",
      ProductId: "",
      Name: "",
      HSNId: ref(),
      PurchasePrice: ref(),
      MRP: ref(),
      MarkupPercentage: ref(),

      StandardRate: 0,
      SalesPrice: ref(),
      VatOn: "",
      IsNoBarcode: true,
      ScheduledInvItemId: 0,
      IsCAPEX: true,
      EntityId: 0,
      EntityOperationId: 0,
      ManufactureName: "",
      ItemGenericName: "",
      LegacyItemId: "",
    });

    const Unitoftransactions: any = ref({
      PackSizeId: ref(),
      OrderUnitId: ref(),
      UnitId: ref(),
      DispenseInNumber: true,

      OrderUnitName: ref(),
      UnitName: ref(),

      PackSizeName: "",
    });

    const Grouping: any = ref({
      ItemTypeId: ref(),
      ItemGroupId: ref(),
      SubGroupId: ref(),
      ProductId: ref(),
      ItemCategoryName: ref(),
      ItemCategoryId: 0,
      ItemGroupName: ref(),
      ItemSubGroupName: ref(),
    });

    const Manufacturing: any = ref({
      ManufatureId: ref(),
    });

    const Generic: any = ref({
      GenericId: ref(),
    });

    const SpecialCategory: any = ref({
      ScheduledItem: false,
      NarcoticItem: false,
      DrugFormulary: false,
      CriticalMedicine: false,
      Alike: false,
      SpecialCategoryItemId: ref() ?? 0,
    });

    const Configuration: any = ref({
      ExpiryDtRequired: false,
      BatchRequired: false,
      IsNonChargable: false,
      IsConsignee: false,
      NoMrp: false,
      AutoConsumed: false,
      HighValueFlag: false,
      IsxrayFilm: false,
      IsGSTExempt: false,
      Asset: false,
      ConfigValue: "",
      ServiceLevel: false,
    });

    async function init() {
      debugger;
      try {
        // const EditID = UpdateId.id;
        try {
          const data_response = await service.GetItemInStoreById(
            route.query.Id,
            props.itemId
          );
          const data1 = data_response["result"];
          console.log(data_response["result"]);
          Object.assign(itemDetails.value, data_response["result"][0]);
          Object.keys(insert_data.value).forEach((key) => {
            if (data1[0][key]) insert_data.value[key] = data1[0][key];
          });

          Object.keys(Unitoftransactions.value).forEach((key) => {
            if (data1[key]) Unitoftransactions.value[key] = data1[key];
          });

          Object.keys(Grouping.value).forEach((key) => {
            if (data1[key]) Grouping.value[key] = data1[key];
          });
          Object.keys(Manufacturing.value).forEach((key) => {
            if (data1[key]) Manufacturing.value[key] = data1[key];
          });

          Object.keys(Generic.value).forEach((key) => {
            if (data1[key]) Generic.value[key] = data1[key];
          });

          Object.keys(SpecialCategory.value).forEach((key) => {
            if (data1[key]) SpecialCategory.value[key] = data1[key];
          });
        } catch (error) {
          alert(error);
        }
      } catch (error) {
        console.error(error);
      }
    }
    return {
      itemDetails,
      insert_data,
      Unitoftransactions,
      Grouping,
      Manufacturing,
      Generic,
      SpecialCategory,
      Configuration,
    };
  },
});
</script>

<style lang="scss" scoped>
// .high-val {
//     font-size: 12px;
//     color: blue;

// }

// .sidbar-label {
//     font-size: 12px;
//     color: #999999;
// }

// .sidbar-val {
//     font-size: 12px;
//     color: #444444;
// }
</style>
